import { useMemo } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../utils/analytics';

/**
 * Hook designed to use a handler if provided (ideally not)
 * Use this for the short-term to support deprecating `analyticsHandler`s that are being provided externally,
 * but fallback to the dispatch provided by `useAnalyticsEvents`
 *
 * In future, potentially use this hook to feature flag the channel we are dispatching to
 */
export var useDispatchAnalytics = function useDispatchAnalytics(handler) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return {
    dispatchAnalytics: useMemo(function () {
      if (handler) {
        return handler;
      }
      return function (payload) {
        createAnalyticsEvent(payload).fire(ANALYTICS_CHANNEL);
      };
    }, [handler, createAnalyticsEvent])
  };
};